// Supabase Auth 카카오 OAuth 콜백 페이지
// Supabase 미사용 시 로그인 페이지로 리다이렉트

import React, { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { Box, Container, CircularProgress, Typography, Alert } from '@mui/material';
import { useSupabaseParentAuth } from '../hooks/useSupabaseParentAuth';
import { supabase } from '../../../lib/supabaseClient';

export default function SupabaseKakaoCallbackPage() {
  const navigate = useNavigate();
  const { user, parent, loading } = useSupabaseParentAuth();
  const [error, setError] = useState('');


  useEffect(() => {
    // Supabase가 없으면 로그인 페이지로 리다이렉트
    if (!supabase) {
      setError('카카오 로그인은 현재 지원되지 않습니다.');
      setTimeout(() => navigate('/parent/login'), 2000);
      return;
    }

    // Supabase Auth가 자동으로 세션을 처리함
    // 세션 로딩이 완료될 때까지 대기
    if (!loading) {
      handleCallback();
    }
  }, [loading, user, parent]);

  const handleCallback = async () => {
    if (!supabase) return;

    if (!user) {
      setError('로그인 세션을 찾을 수 없습니다.');
      setTimeout(() => navigate('/parent/login'), 2000);
      return;
    }

    // 사용자가 인증되었지만 parent 정보가 없으면 자동 생성
    if (!parent) {
      try {
        const userName = user.user_metadata?.full_name || user.user_metadata?.name || '카카오 사용자';
        const userEmail = user.email || '';

        // parents 테이블에 새 레코드 생성
        const { error: insertError } = await supabase
          .from('parents')
          .insert({
            user_id: user.id,
            name: userName,
            phone: null,
            email: userEmail,
            created_at: new Date().toISOString()
          })
          .select()
          .single();

        if (insertError) {
          setError('회원 정보 생성에 실패했습니다. 다시 시도해주세요.');
          setTimeout(() => navigate('/parent/login'), 3000);
          return;
        }

        // 전화번호 연결 페이지로 이동
        navigate('/parent/link-phone');
        return;
      } catch (err) {
        setError('회원 정보 생성 중 오류가 발생했습니다.');
        setTimeout(() => navigate('/parent/login'), 3000);
        return;
      }
    }

    // 모든 것이 정상이면 대시보드로 이동
    navigate('/parent/dashboard');
  };

  return (
    <Box
      sx={{
        minHeight: '100vh',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        background: 'linear-gradient(135deg, #667eea 0%, #764ba2 100%)',
      }}
    >
      <Container maxWidth="sm">
        <Box
          sx={{
            textAlign: 'center',
            backgroundColor: 'white',
            borderRadius: 2,
            padding: 4,
            boxShadow: 3,
          }}
        >
          {error ? (
            <>
              <Alert severity="error" sx={{ mb: 2 }}>
                {error}
              </Alert>
              <Typography variant="body2" color="text.secondary">
                로그인 페이지로 이동합니다...
              </Typography>
            </>
          ) : (
            <>
              <CircularProgress size={60} sx={{ mb: 3, color: '#FEE500' }} />
              <Typography variant="h6" gutterBottom sx={{ fontWeight: 'bold' }}>
                카카오 로그인 처리 중...
              </Typography>
              <Typography variant="body2" color="text.secondary">
                잠시만 기다려주세요.
              </Typography>
            </>
          )}
        </Box>
      </Container>
    </Box>
  );
}
